import React from 'react';
import AppShell from '../../components/app-shell/app-shell';
import PublicShell from '../../components/app-shell/public-shell';
import Link from 'next/link';

import './articles.css';

export default function () {
  return (
    <AppShell seoTitle="Articles" description="Dive deeper into modern calligraphy.">
      <PublicShell>
        <div className="articles">
          <ul>
            <li>
              <Link href="/public/why-calligraphy-dot-org" prefetch>
                <img
                  src="https://storage.googleapis.com/quiver-four.appspot.com/marketing%2Fuploads%2Fblack-favicon-512.png?GoogleAccessId=firebase-adminsdk-z45et@quiver-four.iam.gserviceaccount.com&Expires=2145916800&Signature=Og2ZxWatfvmJ3XHmJCXTw8m20GziWnb4NcTwMU/1syLcRGQqocM4L59cZrfX3%2BB85ioI4yukQYRvjLj3hTr44iJf3I1ugSNCNT/r8v%2B4lr4Pg8IAab4aIkBKwnKnMtD2TFfhp5GwQHezUXQAM5j20PVdqlVy%2BX7ekLUl1G1CngebEq74w%2B%2B6kT0LNLY7ujh2EmYbJ%2BR9cufjONoHYm7di3w3gYqBS2z6Q6lEAE%2Bx1BqffoV1XxhqPCgHv1YUrRyDYzKb%2BzIFy0fMhjkDsVos98aLnBa6n5XJwgZw1LAoW%2B3Gvr78ShV9kt%2BCWjqHHzZaDFxhNMLj3NRDwOnDBO5YDg%3D%3D"
                  alt="Why calligraphy.org?"
                />
              </Link>
              <Link href="/public/why-calligraphy-dot-org" prefetch>
                <a>
                  <span>Why Calligraphy.org?</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/how-to-take-a-class" prefetch>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2FDSC03464.JPG?alt=media&token=2d175a1d-dc7d-4c95-9f3a-47783d60a655"
                  alt="How to take a class"
                />
              </Link>
              <Link href="/public/how-to-take-a-class" prefetch>
                <a>
                  <span>How to Take a Class</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/how-to-submit-an-assignment" prefetch>
                <img
                  src="https://storage.googleapis.com/quiver-four.appspot.com/marketing%2Fuploads%2Fidentify-basic-strokes.png?GoogleAccessId=firebase-adminsdk-z45et@quiver-four.iam.gserviceaccount.com&Expires=2145916800&Signature=dqkfcpfhPKgNEbI7fXLmiC5%2BHlTh1lrYhvOKGT04SfRd4K5%2B3i0QLHWO1F5K/ynpF6z7ZFrDjhn4UFbct12UtwYVgDHdkdf03RwRbqWBjjgMTol2KW9SQ03ILYkVS5htFd2IaFot5uzAlYhQ5O/oNwUWs6G39Ti2%2BDTbJ84iaZn8wGP0Qyo6RlKW2gtsax4Spm5hdRmP7Mom4wWsjdnnk8Epv2svm6UfndRygbpep8XhsEtjTDF4Lqax3nhbUfbJrFTD0yPN0soQRU9yxoTfHH/CuZrRejtmXa%2BHXrgi0czNAPaibnfJvhdimm/C7cokTxBcFi0bAfsRHSeRTTBn6A%3D%3D"
                  alt="How to submit an assignment"
                />
              </Link>
              <Link href="/public/how-to-submit-an-assignment" prefetch>
                <a>
                  <span>How to Submit an Assignment</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/pick-a-class" prefetch>
                <img
                  src="https://storage.googleapis.com/assets-2014.calligraphy.org/cms/admin-seventy-percent-optimized/calligraphy-brush-marker-online-workshop.jpg"
                  alt="How to pick a class"
                />
              </Link>
              <Link href="/public/pick-a-class" prefetch>
                <a>
                  <span>How to Pick a Class</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/calligraphy-supplies-guide" prefetch>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2Fsupplies-basic.png?alt=media&token=1a2c9909-7755-4b15-b2a4-847a52c1986d"
                  alt="Calligraphy Supplies Guide"
                />
              </Link>
              <Link href="/public/calligraphy-supplies-guide" prefetch>
                <a>
                  <span>Calligraphy Supplies Guide</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/testimonials" prefetch>
                <img
                  src="https://storage.googleapis.com/assets-2014.calligraphy.org/cms/admin-seventy-percent-optimized/small/testimonials/jessica-harpole-3.jpg"
                  alt="Learn Modern Calligraphy"
                />
              </Link>
              <Link href="/public/testimonials" prefetch>
                <a>
                  <span>Testimonials</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/modern-calligraphy-kit-description" prefetch>
                <img
                  src="https://storage.googleapis.com/assets-2014.calligraphy.org/cms/admin-seventy-percent-optimized/medium/modern-calligraphy-kit-4.jpg"
                  alt="The Modern Calligraphy Kit"
                />
              </Link>
              <Link href="/public/modern-calligraphy-kit-description" prefetch>
                <a>
                  <span>The Modern Calligraphy Kit</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/brush-calligraphy-kit-description" prefetch>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2F2015-brush-kit.jpg?alt=media&token=d3f8b9a3-1f2a-452e-bd63-8f3db14ee57b"
                  alt="The Brush Calligraphy Kit"
                />
              </Link>
              <Link href="/public/brush-calligraphy-kit-description" prefetch>
                <a>
                  <span>The Brush Calligraphy Kit</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/calligraphy-workshops" prefetch>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2Flanding-page-primary-stephanie-lorraine.jpg?alt=media&token=864f89ea-676d-4b17-b61d-259616064f8b"
                  alt="Calligraphy Workshop"
                />
              </Link>
              <Link href="/public/calligraphy-workshops" prefetch>
                <a>
                  <span>Live Workshops</span>
                </a>
              </Link>
            </li>
            <li>
              <Link href="/public/corporate-events" prefetch>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2FDSC02611.JPG?alt=media&token=4a940b07-c57f-404d-8b6d-6bdac188d87a"
                  alt="Corporate Event"
                />
              </Link>
              <Link href="/public/corporate-events" prefetch>
                <a>
                  <span>Corporate Events</span>
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </PublicShell>
    </AppShell>
  );
}
